import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MOCK_EXAM_LIST } from "../../services/apiConstants";
import "./MockExamListUI.css";
import javaLogo from "../../assets/images/tech-logos/java.svg";
import reactLogo from "../../assets/images/tech-logos/react.svg";
import pythonLogo from "../../assets/images/tech-logos/python.svg";
import sqlLogo from "../../assets/images/tech-logos/sql.svg";
import javascriptLogo from "../../assets/images/tech-logos/javascript.svg";
import cloudLogo from "../../assets/images/tech-logos/cloud.svg";
import defaultLogo from "../../assets/images/tech-logos/default.svg";

function MockExamList() {
  const navigate = useNavigate();
  const [mockExams, setMockExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const isLoggedIn = token && token !== "null" && token !== "undefined";
  const getExamLogo = (exam) => {
    const name = `${exam.title || ""} ${exam.mockExamDesc || ""}`.toLowerCase();

    if (name.includes("react")) return reactLogo;
    if (name.includes("python")) return pythonLogo;
    if (name.includes("sql") || name.includes("database") || name.includes("db")) return sqlLogo;
    if (name.includes("javascript") || name.includes("java script") || name.includes("js")) return javascriptLogo;
    if (name.includes("cloud") || name.includes("devops") || name.includes("aws") || name.includes("azure")) return cloudLogo;
    if (name.includes("java") || name.includes("spring")) return javaLogo;

    return defaultLogo;
  };

  useEffect(() => {
    axios
      .get(MOCK_EXAM_LIST)
      .then((response) => {
        setMockExams(response.data);
      })
      .catch((error) => {
        console.error("Error fetching mock exams:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleStartTrial = (exam) => {
    const examData = {
      mockExamId: exam.mockExamId || exam.id,
      price: exam.price,
      mockExamDesc: exam.title || exam.mockExamDesc
    };

    if (!isLoggedIn) {
      localStorage.setItem("pendingExamData", JSON.stringify(examData));
      navigate("/home", { state: { examData, redirectAfterLogin: "/trialPage" } });
      return;
    }

    localStorage.setItem("examData", JSON.stringify(examData));
    localStorage.removeItem("fullExamAnswers");
    localStorage.removeItem("fullExamScore");
    navigate("/trialPage", { state: examData });
  };

  if (loading) return <p className="exam-loading">Loading mock exams...</p>;

  return (
    <div className="exam-container">
      <div className="exam-hero">
        <div>
          <p className="exam-eyebrow">Mock Exam</p>
          <h1>Start practicing with focused exam sets</h1>
          <p className="subtitle">Browse exams anytime. Sign in only when you are ready to start a trial.</p>
        </div>
        <div className="exam-hero-panel" aria-hidden="true">
          <span>Practice</span>
          <strong>{mockExams.length || 0}</strong>
          <small>available exams</small>
        </div>
      </div>

      <div className="exam-grid">
        {mockExams.map((exam) => (
          <div className="exam-card" key={exam.mockExamId || exam.id}>
            <img
              src={getExamLogo(exam)}
              alt=""
              className="exam-card-image"
            />
            <div className="exam-card-body">
              <span className="exam-label">{exam.level || "Practice"}</span>
              <h3>{exam.title || exam.mockExamDesc}</h3>
              <div className="exam-meta">
                <span>{exam.durationMinutes} mins</span>
                <span>Rs {exam.price}</span>
              </div>
              <div className="card-footer">
                <button onClick={() => handleStartTrial(exam)}>
                  {isLoggedIn ? "Start Free Trial" : "Login to Start"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MockExamList;
